import { render } from "./PackdrawSection.vue?vue&type=template&id=45e1754e&scoped=true"
import script from "./PackdrawSection.vue?vue&type=script&lang=js"
export * from "./PackdrawSection.vue?vue&type=script&lang=js"

import "./PackdrawSection.vue?vue&type=style&index=0&id=45e1754e&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.20_vue@3.5.20_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e1754e"]])

export default __exports__